import varAxios from "../../Comman/axios";
import { heartRunnerLoginUrl } from "../../Comman/apiEndPoints"
import decode from 'jwt-decode';

export const FETCH_HEARTRUNNER_LOGIN_REQUEST = "(heartRunnerLogin) FETCH HEARTRUNNER LOGIN REQUEST";
export const FETCH_HEARTRUNNER_LOGIN_SUCCESS = "(heartRunnerLogin) FETCH HEARTRUNNER LOGIN SUCCESS";
export const FETCH_HEARTRUNNER_LOGIN_ERROR = "(heartRunnerLogin) FETCH HEARTRUNNER LOGIN ERROR";
export const LOGOUT_HEARTRUNNER_REQUEST = "(heartRunnerLogout) LOGOUT HEARTRUNNER REQUEST"

export function fetchheartRunnerLoginRequest({ userName, isLoading, password }) {
    return {
        type: FETCH_HEARTRUNNER_LOGIN_REQUEST,
        userName,
        isLoading,
        password
    }
}

export function heartRunnerLoginError({isLoading,message,loginStatus}) {
    return {
        type: FETCH_HEARTRUNNER_LOGIN_ERROR,
        isLoading,
        message,
        loginStatus
    }
}

export function fetchheartRunnerLoginSuccess({ userName, isLoading, password, Message, loginStatus, authTokenId, userId }) {
    
    return {
        type: FETCH_HEARTRUNNER_LOGIN_SUCCESS,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        userId
    }
}

export function heartRunnerLogin(userName, password, dispatch) {
    let data = {
        Username: userName,
        password: password
    }

    return (dispatch) => {
        dispatch(fetchheartRunnerLoginRequest({ userName: userName, isLoading: true, password: password }));
        return varAxios.post(heartRunnerLoginUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                
                dispatch(
                    fetchheartRunnerLoginSuccess({
                        userName: userName, isLoading: false, password: password,
                        Message: response.data.Message, 
                        loginStatus: response.data.statusCode,
                        authTokenId: response.data.authToken, 
                        userId: response.data.User.UserId
                    }));
                setToken(response.data) // Setting the token in localStorage
                return Promise.resolve(response.data);
            })
            .catch((error,response) => {
                
                dispatch(
                    heartRunnerLoginError({
                        isLoading:false,
                        message: error.response.data.errorMessage, 
                        loginStatus: error.response.data.statusCode, 
                       
                    }));
               
            })

    }
}



export function logOutHeartRunnerRequest({ userName, isLoading, password, Message, loginStatus, authTokenId, adminId, organizationId }) {
    return {
        type: LOGOUT_HEARTRUNNER_REQUEST,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        adminId,
        organizationId
    }
}

export function logOutHeartRunner() {
    return (dispatch) => {
        dispatch(logOutHeartRunnerRequest({ userName: "", isLoading: false, password: "", Message: "", loginStatus: 0, authTokenId: "", adminId: 0, organizationId: 0 }));
    }
}

export function loggedIn(authTokenId) {
    // Checks if there is a saved token and it's still valid 
    const token = getToken() // GEtting token from localstorage
    /*if (token !== authTokenId)
        return false;
    else*/
        return !!token && !isTokenExpired(token) // handwaiving here
}

function isTokenExpired(token) {
    try {
        const decoded = decode(token);
        if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

function setToken(data) {
    // Saves user token to localStorage
    localStorage.setItem('userid_token',data.authToken)
    localStorage.setItem('UserID', data.User.UserId)
    localStorage.removeItem('id_admin_token');
    localStorage.removeItem('OrganizationID');
    sessionStorage.removeItem('id_super_admin_token');
    
}

export function getToken() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('userid_token')
    

}
export function getUserID() {
    // Retrieves the user token from localStorage
    return localStorage.getItem('UserID')
}

export function logout() {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('userid_token');
    localStorage.removeItem('UserID');

}

export function getProfile() {
    // Using jwt-decode npm package to decode the token
    return decode(getToken());
}





